export default {
  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true },
    intermediate_process: { default: false },
    container_id: { required: true },
  }
}
